<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" ref="form" label-width="130px" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="specName" label="品种规格">
              {{ formData.specName || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="manufacturerName" label="生产商">
              {{ formData.manufacturerName || '' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="productionDate" label="生产日期">
              {{ formData.productionDate || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="inspectionDate" label="送检日期">
              {{ formData.inspectionDate || '' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="issueDate" label="签发日期">
              {{ formData.issueDate || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="remark" label="备注">
              {{ formData.remark || '' }}
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 新增创建人、创建时间 -->
        <el-row>
          <el-col :span="12">
            <el-form-item prop="createUserName" label="创建人">
              {{ formData.createUserName || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ctime" label="创建时间">
              {{ formData.ctime || '' }}
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 新增附件只读展示 -->
        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload readonly v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">返回</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'TypeQcReportDetail',
  data() {
    return {
      formData: {
        reportId: '',
        specName: '',
        manufacturerName: '',
        productionDate: '',
        inspectionDate: '',
        issueDate: '',
        remark: '',
        createUserName: '',
        ctime: '',
        fileList: []
      },
      loading: false
    }
  },
  created() {
    if (this.reportId) {
      this.loadData()
    }
  },
  computed: {
    reportId() {
      return this.$route.query.reportId
    }
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.typeQcReport.selectPaTypeQcReportByReportId, {
        params: { reportId: this.reportId }
      }).then(res => {
        res.fileList = res.fileList || []
        this.formData = res
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {
  .el-input,
  .el-select,
  .el-date-editor {
    width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
